import { AnimationUnit } from "./types";

export interface RegisterAnimationAction {
  type: "REGISTER_ANIMATION";
  data: AnimationUnit;
}

export function registerAnimation(
  unit: AnimationUnit
): RegisterAnimationAction {
  return {
    data: unit,
    type: "REGISTER_ANIMATION",
  };
}
